module.exports = __webpack_public_path__ + "img/architectural-evolution-4.a2a97b44.png";